(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["navaclick-training-popup"] && !Shopify.designMode) return;
  try {
    (() => {
  const dialog = document.getElementById('nc-training-popup');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  let trigger;
  const paths = new Set([
    '/widget/booking/rtf8c2dhfIIxCfAGfF1h',
    '/widget/booking/egdtBg9O4AkHlHSeZgJK',
    '/widget/bookings/navaclick-training',
    '/widget/bookings/navaclick-ready-set-click',
    '/widget/bookings/navaclick-training-kit-ready'
  ]);
  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!link || dialog.contains(link) || link.closest('[data-training-direct]') || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    let url;
    try { url = new URL(link.href, location.href); } catch { return; }
    const path = url.pathname.replace(/\/$/, '');
    const calendar = url.hostname === 'api.leadconnectorhq.com' && paths.has(path);
    const chooser = url.origin === location.origin && path === '/pages/schedule-training';
    if (!calendar && !chooser) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    trigger = link;
    dialog.showModal();
    document.documentElement.classList.add('nc-training-open');
    dialog.querySelector('.nc-training-choices a').focus();
  }, true);
  dialog.querySelector('.nc-training-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('nc-training-open');
    if (trigger && trigger.isConnected) trigger.focus();
  });
  dialog.querySelectorAll('.nc-training-choices a').forEach(link => link.addEventListener('click', () => dialog.close()));
})();
  } catch(e) { console.error(e); }
})();

})();
